/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Base Modules (@accedo/xdk-base-modules) 4.2.8
* 
*******************************************************************************/
import{PlayerConfig}from"@accedo/xdk-config";import{ID}from"./id";import html5ExternalSubstitlesConfig from"./extension/HTML5PlayerExternalSubtitle.config";import html5AudioTrackConfig from"./extension/HTML5PlayerAudioTrack.config";const html5player={id:"html5player",importer:()=>import("./HTML5Player.js"),extensions:[html5ExternalSubstitlesConfig,html5AudioTrackConfig]};export default new PlayerConfig(html5player);export{ID};